export const EXTERNAL_SYSTEM_NOT_FOUND_ERROR = 'external_system_not_found';
export const INVALID_REDIRECT_URI_ERROR = 'invalid_redirect_uri';

export class Token {
  public token: string;

  constructor(token: string) {
    this.token = token;
  }
}


export class AuthorizationCodeParams {
  public clientId: string | null = null;
  public responseType: string | null = null;
  public email: string | null = null;
  public redirectURI: string | null = null;
  public scope: string | null = null;

  constructor(clientId: string, responseType: string, email: string, redirectURI: string, scope: string) {
    this.clientId = clientId;
    this.responseType = responseType;
    this.email = email;
    this.redirectURI = redirectURI;
    this.scope = scope;
  }
}

export class CheckTokenParams {
  public accessToken: string;
  public tool: string;

  constructor(accessToken: string, tool: string) {
    this.accessToken = accessToken;
    this.tool = tool;
  }
}

